import type { Slot } from './Slot'

const registry: { [slotId: string]: Slot } = {}
/**
 * SlotRepository houses all rendered slots on the page
 * and provides helper functions for acquiring collections of those slots
 */
export default class SlotRepository {
  static add(slot: Slot): void {
    registry[slot.id] = slot
  }

  static remove(slot: Slot): void {
    delete registry[slot.id]
  }

  static all(): Array<Slot> {
    return Object.keys(registry).map((k) => registry[k])
  }

  static getSlotById(id: string): Slot | undefined {
    const idString = id.replace('_refresh', '')

    return registry[idString]
  }

  static getSlotByWrapper(wrapper: Element): Slot | undefined {
    const slotId = wrapper.getAttribute('data-wrapper') || ''
    const slot = SlotRepository.getSlotById(slotId)

    return slot
  }

  static getSlotByGSlot(slot: googletag.Slot): Slot | undefined {
    return SlotRepository.getSlotById(slot.getSlotElementId())
  }

  static get adhesionSlot(): Slot | undefined {
    const adhesion = SlotRepository.all().filter(
      (s) => s.adUnitId.indexOf('adhesion') !== -1
    )
    if (adhesion.length) {
      return adhesion.pop()
    }
  }

  static getRecipeSlots(): Array<Slot> {
    return SlotRepository.all().filter((slot) => slot.type === 'Recipe')
  }
}
